// src/hooks/useCVDetail.js
import { useQuery } from 'react-query';
import { CVHttpService } from '../services';

const useCVDetail = (id) => {
  return useQuery(['cvDetail', id], () => CVHttpService.loadCV(id), {
    enabled: !!id, // Only run the query if id is provided
  });
};

export default useCVDetail;
